import { Base, PageObject } from '@testsigmainc/models';
import { deserialize, serializable } from 'serializr';
import {
  AfterSuiteFailActionType,
  AfterSuiteRunType,
} from '@modules/test-development/enums/after-suite-action.enum';

export class AfterTestSuiteConfig extends Base implements PageObject {
  @serializable
  public id: number;

  @serializable
  public suiteId: number;

  @serializable
  public afterSuiteRunType: AfterSuiteRunType =
    AfterSuiteRunType.RUN_AFTER_SUITE;

  @serializable
  public afterSuiteFailActionType: AfterSuiteFailActionType =
    AfterSuiteFailActionType.FAIL;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(AfterTestSuiteConfig, input));
  }
}
